import { ExpandedSectionHeaderCombinedProps } from './types';

const usePresenter = (props: ExpandedSectionHeaderCombinedProps): ExpandedSectionHeaderCombinedProps => {
  return props;
};

export default usePresenter;
